module.exports = __webpack_public_path__ + "img/rewards.7af4e69c.png";